import Confirm, { type ConfirmProps } from "@/shared/ui/Confirm";

export default function CreateCharacterConfirmBackModal(props: ConfirmProps) {
  return (
    <Confirm {...props}>
      <div className="text-16 font-bold text-white text-center w-full">
        Вы точно хотите прекратить создание нового персонажа?
      </div>
    </Confirm>
  );
}
